import s from './StoreTab.module.scss';
import Tab from './Tab';
export const StoreTab = ({ curIndex, setCurIndex }) => {
  return (
    <div className={s.root}>
      {[
        {
          title: 'Store',
          icon: '',
        },
        {
          title: 'ML Exclusive',
          icon: 'https://parkplus-bkt-img.parkplus.io/production/team/public/FS_20240104160730062768.png',
        },
      ].map((item, index) => (
        <div
          key={index}
          onClick={() => {
            setCurIndex(index);
          }}
        >
          <Tab
            title={item.title}
            isActive={index === curIndex}
            icon={item.icon}
          />
        </div>
      ))}
    </div>
  );
};
